<div class="flex gap-1 items-center">
  <span class="w-5 aspect-square grid place-items-center bg-primary rounded-full text-white cursor-pointer pulse"><mat-icon
    style="font-size: 14px;
    width: 14px;
    height: 14px;" [matTooltip]="tip" [matTooltipPosition]="'above'">{{ icon }}</mat-icon></span>

  @if(customView) {
    <span class="pt-1">
      <ng-container
        [ngTemplateOutlet]="customView">
      </ng-container>
    </span>
  } @else {
    <span>{{ value }}</span>
  }
</div>
